__turbopack_context__.v({
  "ctaBlock": "_8BEVG_ctaBlock",
  "ctaLead": "_8BEVG_ctaLead",
  "eyebrow": "_8BEVG_eyebrow" + " " + __turbopack_context__.i(917291)["monoUppercase"],
  "heroMiddle": "_8BEVG_heroMiddle",
  "heroSection": "_8BEVG_heroSection",
  "title": "_8BEVG_title",
  "titleBlock": "_8BEVG_titleBlock",
});
